import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Discovery from './pages/Discovery';
import UserHistory from './pages/UserHistory';
import Content2Learn from './pages/Content2Learn';
import Login from './components/auth/Login';
import SignUp from './components/auth/SignUp';
import ProcessedContent from './pages/ProcessedContent';
import ProtectedRoute from './components/ProtectedRoute';
import ContentViewer from './pages/ContentViewer';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <div className="container mx-auto px-4 flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/content2learn" element={<Content2Learn />} />
                <Route path="/processed/:hash" element={<ProcessedContent />} />
                <Route path="/discovery" element={<Discovery />} />
                <Route
                  path="/history"
                  element={
                    <ProtectedRoute>
                      <UserHistory />
                    </ProtectedRoute>
                  }
                />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/viewer" element={<ContentViewer />} />
                <Route path="/viewer/:id" element={<ContentViewer />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 